import BaseModalStore from '@src/components/modal-container/base-modal-store';
import useModal from '@src/utils/hooks/use-modal';
import redeemModal from './redeem-modal';
import RedeemModalStore from './redeem-modal/store';
import { observable } from 'mobx';
import { useMount } from 'ahooks';
import { useEffect } from 'react';
import { $$tracker } from '@src/tracker';

class CdkeyModalStore extends BaseModalStore {
  name = 'cdkey-modal';

  @observable $main = {};

  constructor(options = {}) {
    super();
    Object.assign(this, options);
  }

  /**
   * 点击关闭弹窗
   * 重写关闭事件, 补充了弹窗特定的关闭回调
   */
  onClickClose = () => {
    if (this.redeemModalStore.isActive || this.redeemModalStore.isOpen) {
      this.redeemModalStore.onClickClose();
    } else {
      this.isOpen = false;
      this.isActive = false;
      this.clearStyle();
    }
  };

  login() {
    const { isDownloadStage } = this.$globalStore;
    if (isDownloadStage) {
      super.login();
    } else {
      this.$main.appointmentModal.open({
        extraStore: {
          appointmentSuccessCallBack: () => {
            this.redeemModal.open();
          }
        }
      });
    }
  }

  /**
   * 领取奖励
   */
  redeemCdKey = () => {
    const { accountInfo } = this.$globalStore;
    if (accountInfo) {
      $$tracker.clickHomeBGRewards();
      this.redeemModal.open();
    } else {
      this.login();
    }
  };

  //礼包码显示弹窗
  @observable redeemModal = null;

  @observable redeemModalStore = new RedeemModalStore();

  use() {
    super.use();

    this.redeemModal = useModal(redeemModal, { store: this.redeemModalStore }, { className: 'redeem-modal' });

    const { accountInfo } = this.$globalStore;

    useEffect(
      () => {
        this.redeemCdKey();
      },
      [this.$globalStore.accountInfo]
    );

    useMount(() => {
      // 一进来先判断是否已经登录，已登录则直接弹窗拷贝窗口
      if (accountInfo) {
        setTimeout(() => {
          this.redeemModal.open();
        }, 200);
      }
    });
  }
}

export default CdkeyModalStore;
